import { usePendingProjectCountsQuery } from "../../../../../hooks/dashboardHooks/usePendingProjectCountQuery";
import { BookingsScreenTabLabelTag } from "../BookingsScreenTabLabelTag/BookingsScreenTabLabelTag";

export const BookingsScreenProjectsTabLabel = () => {
  const { data, isLoading, isError } = usePendingProjectCountsQuery();
  return (
    <>
      Projects
      {Boolean(data?.pending_scheduled_projects_count) && (
        <BookingsScreenTabLabelTag isLoading={isLoading} isError={isError}>
          ({data?.pending_scheduled_projects_count ?? 0})
        </BookingsScreenTabLabelTag>
      )}
    </>
  );
};
